import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	statusLabel: {
		id: 'search-page.filters.names.status',
		defaultMessage: 'Status',
		description: 'Label for filtering by status',
	},
});
